(() => {
  // Presentation only: never rewrite URLs, IDs, form values, or product JSON.
  const unit = /(^|[^\p{L}_])ml(?![\p{L}\p{N}_])/giu;
  const excluded = 'script, style, textarea, input, code, pre, noscript, [contenteditable="true"]';
  function normalize(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const update = (node) => {
      if (!node.parentElement || node.parentElement.closest(excluded)) return;
      // An option without an explicit value derives its submitted value from text.
      if (node.parentElement.matches('option:not([value])')) return;
      const next = node.data.replace(unit, '$1ML');
      if (next !== node.data) node.data = next;
    };
    if (root.nodeType === Node.TEXT_NODE) update(root);
    else while (walker.nextNode()) update(walker.currentNode);
  }
  function init() {
    normalize(document.body);
    new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'characterData') normalize(record.target);
        else record.addedNodes.forEach(normalize);
      }
    }).observe(document.body, { subtree: true, childList: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* KI-Kennzeichnung (Art. 50 KI-VO): Bilder mit KI-erzeugten Personen erhalten direkt am Bild
   den Hinweis "Mit KI erstellt". Produktfotos/Verpackungen bleiben unmarkiert.
   Pflege: Dateinamen-Muster in AI_SRC ergänzen; einzelnes Bild manuell: data-drf-ai="true",
   Ausnahme: data-drf-ai="false". */
(() => {
  const AI_SRC = [
    /drf-v[456]-(?!serum-macro)[a-z0-9-]+-(desktop|mobile)/i,
    /drf-hero-(still|mobile|desktop)/i,
    /drf-kraeuteroel-(application|anwendung)/i
  ];
  const PERSON_ALT = /\b(frau|mann|person|model|hand|hände|haende|finger|fingerspitzen?|wange|gesicht|hals|nacken|schulter|woman|women|man|person|hands?|fingers?|fingertips?|cheek|face|neck|shoulder|blonde|brunette)\b/i;
  const NOT_AI = /ralph|thelen|logo|portr(ä|ae)t von|signature|unterschrift/i;
  const lang = (document.documentElement.lang || 'de').toLowerCase().startsWith('en') ? 'en' : 'de';
  const TEXT = lang === 'en' ? 'Created with AI' : 'Mit KI erstellt';

  function style() {
    if (document.getElementById('drf-ai-style')) return;
    const s = document.createElement('style');
    s.id = 'drf-ai-style';
    s.textContent = '.drf-ai-tag{position:absolute;left:12px;bottom:12px;z-index:3;display:inline-flex;align-items:center;gap:5px;padding:4px 9px;border-radius:999px;background:rgba(255,255,255,.82);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);color:#0d1d16;font:600 10.5px/1.2 -apple-system,BlinkMacSystemFont,"Helvetica Neue",Arial,sans-serif;letter-spacing:.01em;pointer-events:none;white-space:nowrap}.drf-ai-tag:before{content:"";width:5px;height:5px;border-radius:50%;background:#53705f}@media(max-width:600px){.drf-ai-tag{left:8px;bottom:8px;font-size:10px;padding:3px 8px}}';
    document.head.appendChild(s);
  }
  function isAi(img) {
    const flag = img.getAttribute('data-drf-ai') || (img.closest('[data-drf-ai]') && img.closest('[data-drf-ai]').getAttribute('data-drf-ai'));
    if (flag === 'false') return false;
    if (flag === 'true') return true;
    const src = (img.currentSrc || img.src || '') + ' ' + (img.getAttribute('srcset') || '') + ' ' + (img.getAttribute('data-src') || '');
    const alt = img.getAttribute('alt') || '';
    if (NOT_AI.test(alt) || NOT_AI.test(src)) return false;
    if (AI_SRC.some((r) => r.test(src))) return true;
    return PERSON_ALT.test(alt);
  }
  function tag(img) {
    if (img.dataset.drfAiDone) return;
    img.dataset.drfAiDone = '1';
    if (img.closest('header, footer, .site-header, .drf-cart, [data-cart-drawer]')) return;
    if (!isAi(img)) return;
    const pic = img.closest('picture');
    const host = (pic || img).parentElement;
    if (!host || host.querySelector(':scope > .drf-ai-tag')) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    const t = document.createElement('span');
    t.className = 'drf-ai-tag';
    t.textContent = TEXT;
    host.appendChild(t);
  }
  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.tagName === 'IMG') tag(root);
    root.querySelectorAll('img').forEach(tag);
  }
  function init() {
    style();
    scan(document.body);
    new MutationObserver((rs) => rs.forEach((r) => r.addedNodes.forEach((n) => n.nodeType === 1 && scan(n)))).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', (e) => scan(e.target));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
